// Angular Imports
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
// This Module's Components
import { InformationComponent } from './information.component';

@NgModule({
  imports: [BrowserModule],
  declarations: [InformationComponent],
  exports: [InformationComponent]
})
export class InformationModule {}
